
import { Component, OnInit, Input, ChangeDetectionStrategy, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import * as fromPaymentCredit from '../../../screens/payment-credit/state/payment-credit.selectors';
import * as PaymentCreditAction from '../../../screens/payment-credit/state/payment-credit.actions';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { slideInDownAnimation } from 'src/app/app.animation';
import { AngularMaterialService } from 'src/commons';
import { FormCCService } from 'src/commons/services/formCC.service';

@Component({
    selector: 'payment-credit-ext-table-component',
    templateUrl: 'payment-credit-ext-table-component.html',
    styleUrls: ['payment-credit-ext-table-component.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentCreditExtTableComponent implements OnInit, OnChanges {

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @Input() isLoading: boolean;
    @Input() data: any[];
    @Input() displayedColumns: any[];

    localData: any[];
    datePipe = new DatePipe('en-US');
    public dataSource: MatTableDataSource<any>;

    constructor(
        private store: Store<fromPaymentCredit.State>,
        private router: Router,
        private formCCService: FormCCService,
        private ams: AngularMaterialService,
    ) { }

    buildDataSource(data: any) {
        const filter = this.dataSource !== undefined ? this.dataSource.filter : '';
        this.dataSource = new MatTableDataSource(data);

        this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
                case 'orgInfoName': return item.orgInfoName.toLowerCase();
                case 'orgInfoSubsection': return isNaN(item.orgInfoSubsection) ? item.orgInfoSubsection : +item.orgInfoSubsection;
                case 'formName': return item.formName.toLowerCase();
                case 'requestNo': return +item.requestNo.substring(2);
                case 'status': return item.status.toLowerCase();
                case 'OeBSStatusCode': return item.FormCCOeBS.validateStatusCode.toLowerCase();
                case 'dateRequest': return new Date(item.dateRequest);
                default: return item[property];
            }
        };
        this.dataSource.filterPredicate = (data, filter: string) => {
            const accumulator = (currentTerm, key) => {
                switch (key) {
                    case 'OrgInfo':
                        return currentTerm + data.orgInfoName + this.getTaxExemptStatus(data.orgInfoSubsection);
                    case 'FormCCLogInfo':
                        return currentTerm + data.FormCCLogInfo.empName
                            + data.FormCCLogInfo.title
                            + data.FormCCLogInfo.comment;
                    case 'effdt':
                        const newDate = this.datePipe.transform(data.effdt, 'MM-dd-yyyy');
                        return currentTerm + newDate.toString();
                    default:
                        return currentTerm + data[key];
                }
            };
            const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
            // Transform the filter by converting it to lowercase and removing whitespace.
            const transformedFilter = filter.trim().toLowerCase();
            return dataStr.includes(transformedFilter);
        };
        this.dataSource.filter = filter;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    public ngOnInit() {
        setTimeout(() => {
            this.localData = this.data;
            this.buildDataSource(this.localData);
        });
    }

    getTaxExemptStatus(value) {
        if (value === '')
            return 'Other';
        else if (isNaN(value) || +value === 0) {
            return value;
        } else {
            return `501(c)(${+value})`;
        }
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes['data']) {
            setTimeout(() => {
                this.localData = changes['data'].currentValue;
                this.buildDataSource(this.localData);
            });
        }
    }

    public payAsCreditCard(row) {
        let confirmationData: any = {};
        const statusId = row.statusId;
        confirmationData.formccId = row.formccId == undefined ? row.formId : row.formccId;
        confirmationData.requestNumber = row.requestNo;
        confirmationData.requestName = row.formName;
        confirmationData.confirmationNoCC = '';
        const grant = row.requestNo.substring(0, 2);
        this.ams.showCreditCardConfirmation('Pay As Credit Card', '', confirmationData);
        this.ams.creditCardConfirmation.afterClosed().subscribe(result => {
            if (result) {
                let confirmationResult: any = {};
                confirmationResult.formId = result.formccId;
                confirmationResult.requestNumber = result.requestNumber;
                confirmationResult.requestName = result.requestName;
                confirmationResult.confirmationNoCC = result.confirmationNoCC;
                confirmationResult.statusId = statusId;
                this.store.dispatch(new PaymentCreditAction.ProcessFormExtAsCredit(confirmationResult));
            }
        });
    }

    public getStatusClass(status): string {
        const possibleStatus = ['Approved', 'Rejected', 'INVALID', 'VALID', 'SUCCESSFUL'];
        return possibleStatus.indexOf(status) > -1 && status.toLowerCase();
    }

    public selectRow(row): void {
        this.formCCService.setIsAdminReadOnly(row.formId);
        switch (row.requestNo.substring(0, 2)) {
            case 'CG':
                this.router.navigate([`charity-forms/community-grant/${row.formId}`]);
                break;
            case 'ES':
                this.router.navigate([`charity-forms/event-sponsorship/${row.formId}`]);
                break;
            case 'PP':
                this.router.navigate([`charity-forms/plant-planet/${row.formId}`]);
                break;
            case 'CI':
                this.router.navigate([`charity-forms/community-investment/${row.formId}`]);
                break;
            case 'FO':
                this.router.navigate([`charity-forms/foundation/${row.formId}`]);
                break;
        }
    }

    public applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }

}